import { FeedbackConfirmation } from '../../molecules/FeedbackConfirmation/FeedbackConfirmation';
import { FeedbackModal } from '../../organisms/FeedbackModal/FeedbackModal';
import { FeedbackTemplateProps } from './FeedbackTemplate.types';

export const FeedbackTemplate = ({
  submitted,
  microcopy,
  onSubmit,
  onCompleted,
  className = '',
}: FeedbackTemplateProps) => {
  return (
    <div className={className}>
      {submitted ? (
        <FeedbackConfirmation
          microcopy={microcopy.confirmation}
          {...(onCompleted ? { onClose: onCompleted } : {})}
        />
      ) : (
        <FeedbackModal microcopy={microcopy.modal} onSubmit={onSubmit} />
      )}
    </div>
  );
};
